import {makeStyles} from '@material-ui/core';
import { Colors } from '../../../styles/Colors';

export const useStyles = makeStyles(() => ({

    container: {
        width: 'fit-content',
        height: 24,
        display: 'flex',
        borderRadius: 16,
        background: 'rgba(228, 235, 243, 1)',
        padding: '8px !important',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginRight: 24,
        cursor: 'pointer',
        userSelect: 'none'
    },

    icon: {
        width: 20,
        height: 16,
        color: 'rgba(76, 134, 183, 1)',
        pointerEvents: 'none',
        display: 'block',

        '& svg': {
            '& path': {
                fill: `rgba(76, 134, 183, 1) !important`,
                fillOpacity: 1,
            },
        },
    },

    label: {
        color: 'rgba(76, 134, 183, 1)',
        fontWeight: 700,
        fontSize: 16,
        lineHeight: '16px',
        letterSpacing: '0%',
        marginLeft: 6,
        marginRight: 6
    },

    badge: {
        background: 'rgba(246, 133, 31, 1)',
        borderRadius: 10,
        color: Colors.White,
        fontWeight: 500,
        fontSize: 14,
        textAlign: 'center',
        verticalAlign: 'middle',
        height: 20,
        lineHeight: '20px',
        width: 'fit-content',
        minWidth: 8,
        paddingLeft: 6,
        paddingRight: 6,
    },

    iconContainer: {
        padding: '4px 2px',
        height: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
}));